export default "__VITE_ASSET__DeoGMJhW__"